<template>
  <div
    class="image-container"
    :class="{ 'image-container-line': displayedInLine }"
  >
    <div
      v-for="option in options"
      :key="option"
      class="image-wrapper bg-light"
      :class="{ 'image-wrapper-list': !displayedInLine }"
    >
      <img
        :src="getLayout(option)"
        @click="handleImageClick(option)"
      >
      <div
        class="row justify-content-center radio-wrapper"
        :class="{ 'radio-wrapper-list': !displayedInLine }"
      >
        <input
          type="radio"
          name="options"
          :key="`option-${option}`"
          :disabled="disabled"
          :id="`option-${option}`"
          :checked="option === selectedOption"
          @change="changeValue(option)"
        >
      </div>
    </div>
  </div>
</template>
<script>

function initialData() {
  return {
    selectedOption: null,
    options: [1, 2, 3],
    creativeSizesInLine: ['300x600', '300x250'],
    valueSelected: null,
  };
}

export default {
  name: 'LayoutGroup',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 2,
    },
    creativeSize: {
      type: String,
      default: '300x600',
    },
  },
  data() {
    return initialData();
  },
  computed: {
    displayedInLine() {
      return this.creativeSizesInLine.includes(this.creativeSize);
    },
  },
  methods: {
    getLayout(optionValue) {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return require(`@/assets/creatives/${this.creativeSize}_layout_${optionValue}.svg`);
    },
    changeValue(newValue) {
      this.$emit('updateValue', newValue);
    },
    handleImageClick(option) {
      if (!this.disabled) {
        this.selectedOption = option;
      }
    },
  },
  created() {
    this.selectedOption = this.value;
  },
};
</script>
<style scoped lang="scss">
input[type=radio]{
  transform:scale(1.25);
}
.radio-wrapper {
  margin-top: 5px;
}
.image-wrapper {
  padding: 7px;
}
.image-container-line {
  display: flex;
  gap: 15px;
}
.image-wrapper-list {
  margin-top: 10px;
  display: flex;
}
.image-wrapper-list img {
  padding: 2px;
  order: 2;
  margin-left: 20px;
  max-width: calc(100% - 30px);
}
.radio-wrapper-list {
  margin-top: 0;
  order: 1;
}
.radio-wrapper-list input[type="radio"] {
  margin-left: 20px;
}
</style>
